import { useNavigate } from 'react-router-dom';
import { useSEO } from '../hooks/useSEO';

export default function NotFoundPage() {
  const navigate = useNavigate();
  useSEO({ title: 'Page Not Found' });

  return (
    <div style={{ minHeight: 'calc(100vh - 68px)', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--cream)', padding: 24 }}>
      <div style={{ textAlign: 'center', maxWidth: 480 }}>
        <div style={{ fontSize: 80, marginBottom: 16, lineHeight: 1 }}>🍒</div>
        <h1 style={{ fontFamily: "'Playfair Display',serif", fontSize: 'clamp(48px,8vw,72px)', fontWeight: 900, color: 'var(--cherry)', lineHeight: 1, marginBottom: 8 }}>404</h1>
        <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 24, fontWeight: 700, marginBottom: 12 }}>Page not found</h2>
        <p style={{ fontSize: 15, color: 'var(--text-soft)', lineHeight: 1.6, marginBottom: 32 }}>
          The page you're looking for doesn't exist or may have been moved.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button className="btn btn-cherry" onClick={() => navigate('/')}>Go home</button>
          <button className="btn btn-ghost" onClick={() => navigate('/browse')}>Browse listings</button>
          <button className="btn btn-ghost" onClick={() => navigate(-1)}>← Go back</button>
        </div>
      </div>
    </div>
  );
}
